import { ChangeDetectorRef, Component, Inject } from '@angular/core'
import { FormControl } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'
import { debounceTime } from 'rxjs/operators'
import { BaseDialogComponent } from '../../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../../common/stringable.decorator'
import { ONE_SECOND } from '../../../../../../constants/DueTime'
import { JSONRpcResponse } from '../../../../../../Interfaces/JSONRpcResponse'
import { MustStringable } from '../../../../../../Interfaces/MustStringable'
import { DisplayTitlePipe } from '../../../../../../pipes/atyl/displayTitle.pipe'
import { DialogService, TiersService } from '../../../../../../services'

const KEY = 'form-input-adresse-search'

@Component({
	selector: 'atyl-search-adresse',
	templateUrl: './search-adresse.component.html',
	styleUrls: ['./search-adresse.component.scss']
})
@Stringable({
	key: KEY,
	path: 'motor-form-atyl/form-atyl-input/form-input-type/form-input-adresse/search-adresse'
})
export class SearchAdresseComponent extends BaseDialogComponent implements MustStringable {

	searchQuery = ''
	searchInput = new FormControl(null)
	tiersList: any[] = []
	selectedTiers: any
	@StringableValues(KEY) strings: any
	constructor(
		dialogRef: MatDialogRef<SearchAdresseComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		changeDetectorRef: ChangeDetectorRef,
		dialogService: DialogService,
		private tiersService: TiersService,
		private displayTitlePipe: DisplayTitlePipe
	) {

		super(dialogRef, dialogService, changeDetectorRef)
	}
	ngOnInit() {
		this.__defaultValues__()
		this.__handelUserInput__()
	}
	private __defaultValues__() {
		if (this.data && this.data.selectedTiers) {
			this.selectedTiers = this.data.selectedTiers
			this.searchInput.setValue(this.displayTitlePipe.transform(this.selectedTiers))
		}
	}

	private __handelUserInput__() {
		this.subscriptions.push(
			this.searchInput.valueChanges.pipe(debounceTime(ONE_SECOND)).subscribe(value => {
				this.searchQuery = value
				if (typeof this.searchQuery === 'string') {
					this.__handleSearch__()
				}
			})
		)
	}
	private __handleSearch__() {
		this.tiersService.searchTiers(this.searchQuery).subscribe((tiersList: JSONRpcResponse) => {
			this.tiersList = tiersList.result
		})
	}
	displayFunction(tiers: any) {
		return this.displayTitlePipe.transform(tiers)
	}
	tiersSelected(tiers: any) {
		this.selectedTiers = null
		this.selectedTiers = tiers
		this.changeDetectorRef.detectChanges()
	}
	onValidate() {
		this.dialogRef.close(this.selectedTiers)
	}
	onCancel() {
		this.dialogRef.close()
	}
}
